import { render, staticRenderFns } from "./pagination_list.vue?vue&type=template&id=6835db11&scoped=true&"
import script from "./pagination_list.vue?vue&type=script&lang=js&"
export * from "./pagination_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6835db11",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6835db11')) {
      api.createRecord('6835db11', component.options)
    } else {
      api.reload('6835db11', component.options)
    }
    module.hot.accept("./pagination_list.vue?vue&type=template&id=6835db11&scoped=true&", function () {
      api.rerender('6835db11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/sys/list/pagination_list.vue"
export default component.exports